<template>
  <div id="app" class="pdf-conainer-div">
    <div class="mybtnclass">
      <span v-if="lurl" @click="downpdf()" class="pdf-download">DOWNLOAD</span>
      &nbsp;
      <span v-if="lurl" @click="openpdf()" class="pdf-open">OPEN</span>
    </div>
    <PDFViewer
      v-if="url"
      v-bind="{url, allowSelection, existingSelections, reasonOptions, handleSaveSelections,currentSelections}"
      @document-errored="onDocumentErrored"
      @onDocumentRendered="onDocumentRendered"
      ref="pdfViewer"
      >
      <!-- <PDFUploader
        v-if="enableUploader"
        :documentError="documentError"
        @updated="urlUpdated"
        slot="header"
        class="header-item"
        /> -->
    </PDFViewer>
    <v-snackbar
      v-model="snackbar"
    >
      {{ errortext }}
      <v-btn
        color="error"
        text
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import PDFViewer from '@/components/pdf/components/PDFViewer.vue'
import { DOCUMENT_SELECTION_EVENTS } from '@/components/pdf/utils/constants'

const { getValidSelections } = DOCUMENT_SELECTION_EVENTS

export default {
  name: 'pdfViewer',

  components: {
    PDFViewer
  },

  data () {
    return {
      url: null,
      documentError: undefined,
      enableUploader: true,
      snackbar: false,
      errortext: '',
      lurl: false
    }
  },
  props: {
    pdfURL: null,
    allowSelection: {
      type: Boolean,
      default: false
    },
    currentSelections: {
      type: Array,
      default: () => []
    },
    existingSelections: {
      type: Array,
      default: () => []
    },
    reasonOptions: {
      type: Array,
      default: () => []
    },
    handleSaveSelections: {
      type: Function,
      default: () => {}
    }
  },
  created () {
    this.$on(getValidSelections, (callback) => {
      this.$refs.pdfViewer.$emit(getValidSelections, callback)
    })
  },
  methods: {
    urlUpdated (url) {
      this.documentError = undefined
      if (url.includes('api')) {
        this.url = url
      } else {
        this.url = null
      }
    },
    onDocumentErrored (e) {
      this.documentError = e.text
      this.url = null
    },
    onDocumentRendered (e) {
      console.log(e)
      this.lurl = true
    },
    forceFileDownload (response) {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      let fname = this.url.split('/').pop()
      link.setAttribute('download', fname) // or any other extension
      document.body.appendChild(link)
      link.click()
    },
    downpdf () {
      if (this.url) {
        console.log(this.url)
        this.$http({
          method: 'get',
          url: this.url,
          responseType: 'arraybuffer'
        }).then(response => { this.forceFileDownload(response) })
          .catch(() => { this.errortext = 'Unable to download file.'; this.snackbar = true })
      }
    },
    openpdf () {
      if (this.url) {
        window.open(this.url, '_blank', 'location=yes,height=600,width=900,scrollbars=yes,status=yes')
      }
    }
  },
  watch: {
    pdfURL: {
      immediate: true,
      handler (newVal, oldVal) {
        this.url = newVal
      }
    }
  }
}
</script>

<style>
label.form {
  color: black;
  font-family: Monaco, 'Courier New', Courier, monospace;
  font-weight: bold;
  margin-bottom: 2em;
  display: block;
}
input {
  padding: 0.45em;
  font-size: 1em;
}
.error {
  border: 1px solid red;
  background: pink;
  color: red;
  padding: 0.5em 3em;
  display: inline;
}

a.icon {
  cursor: pointer;
  display: block;
  border: 1px #333 solid;
  background: white;
  color: #333;
  font-weight: bold;
  padding: 0.25em;
  width: 2em;
  height: 2em;
  font-size: 1.5em;
}

.box-shadow {
  box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11), 0 5px 15px 0 rgba(0, 0, 0, 0.08);
}
.overflow-hidden {
  overflow: hidden;
}
.pdf-conainer-div {
  position: relative;
}
.mybtnclass span.pdf-download,.mybtnclass span.pdf-open{
  position: absolute;
  top:1em;
  right:6em;
  color:#fff;
  z-index:100;
  cursor: pointer;
  background-color: #1976d2 !important;
  border-color: #1976d2 !important;
  padding:8px;
  box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
}
.mybtnclass span.pdf-open{
  right:1em;
}
.mybtnclass span:hover{
  opacity:.9;
}
@media print {
  body {
    background-color: transparent;
  }
  #app {
    margin: 0;
    padding: 0;
  }
}
</style>
